import React, {useState, useEffect} from 'react'
import axios from 'axios'
import logo2 from './logo.png';
import { Link } from 'react-router-dom';



function AuthorPush(){
    

    

  const [selectedFile, setSelectedFile] = useState(null);

  // Handler for when a file is selected
  const handleFileChange = (event) => {
    // Get the first file from the selection
    setSelectedFile(event.target.files[0]);
  };

  // Handler for the upload button click
  const handleUpload = () => {
    if (selectedFile) {
      // Proceed with sending the file to the server
      //uploadFileToServer(selectedFile);
       alert(selectedFile.name + " uploaded successfully!");
    } else {
      alert("Please select a file first!");
    }
  };

  const [selectedAnswer, setSelectedAnswer] = useState('No'); // State to store the selected value

  const answers = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
    
  ];
 const handleChangeAns = (event) => {
     
    setSelectedAnswer(event.target.value); // Update state on change
    
  };

    //const submitEntry =() =>{}

    // useEffect(()=>
  //  {
     //   axios.get('https://jtvetapi.onrender.com/entries')
     //   .then(res=>setEntries(res.data))
        
        
   // }, [])

  //  const submitEntry = () =>{ 
   //     axios.post('https://jtvetapi.onrender.com/entries', {title, author, date, doi})
   //     .then(()=>window.location.reload())
  //  }


return(
    
    <div className="App"
    
    
    >
         <img src={logo2} className="App-logo" alt="logo" />
        <h1>Journal of Technical and Vocational Education and Training</h1>
        <h2>Welcome Author!</h2>
        <p><i>Upload your article below, must be in Microsoft Word Format</i></p>
        <form className=''>
         <input type='file' className='input' onChange={handleFileChange}/>
         <br/>
        <br/>
        <p className=''>Is this an original Manuscript and has not been published elsewhere?</p>
       
        <select value={selectedAnswer} onChange={handleChangeAns} className='title-select'>
        {answers.map((answer) => (
          <option key={answer.value} value={answer.value}>
            {answer.label}
          </option>
        ))}

      </select>
         <br/>
        <button className='button' type="submit" onClick={handleUpload}>Submit</button>
       {selectedFile && <p>Selected file: {selectedFile.name}</p>}
        
         
        </form>
        <br/>
        <p>Back to <Link to="/">home page</Link></p>
       <footer><small>Copyright &copy; 2026 Designed by | ISITEC</small></footer>
    </div>

)
}

export default AuthorPush